import {Tooltip} from '@dropbox/dig-components/tooltips';
import {UIIcon} from '@dropbox/dig-icons';
import {InfoLine} from '@dropbox/dig-icons/assets';

import styles from './EarningsTile.module.css';

/**
 * Hover/focus info icon, matching the metric editor's header tooltips
 * (WorkstreamManageOutcomesModal, MetricForecastGrid).
 */
export const EarningsInfoTooltip = ({title}: {title: string}) => (
  <Tooltip title={title} placement="top">
    <span className={styles.infoIcon} aria-label={title} role="img" tabIndex={0}>
      <UIIcon src={InfoLine} size="small" />
    </span>
  </Tooltip>
);
